import styled from 'styled-components'
import {
  LIGHT_THEME_NAME,
} from '@/constants/names'


export const Header = styled.div`
  width: 100vw;
  display: flex;
  height: 40px;
  align-items: center;
  gap: 50px;
  padding-left: 10px;
  background-color: #FAFBFB;
  z-index: 100;
  position: absolute;

  & > svg {
    cursor: pointer;
  }
`

export const Title = styled.h3`
  font-family: 'Roboto', sans-serif;
  display: flex;
  cursor: pointer;
  height: 100%;
  align-items: center;
  align-self: center;
  justify-content: flex-start;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  flex-grow: 1;
  ${({ isBigChildren }) => isBigChildren && `
    overflow: hidden;
  `}
  ${({ theme }) => {
    if (theme.themeName === LIGHT_THEME_NAME) {
      return `
        font-size: 1.4rem;
        font-weight: 500;
      `
    }
    return `
      font-weight: ${theme.fontWeights.bold};
      font-size: 1.4rem;
      line-height: 2.4rem;
    `
  }}
`


export const Container = styled.div`
  padding-top: 40px;
`

export const InfoBlock = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.5;
  text-align: left;
  padding: 10px;
  white-space: pre-wrap;
`
export const WrapperWidgetBlock = styled.div`
`

export const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 10px 0 10px;
  overflow-y: auto;
  overflow-x: hidden;
`
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  background-color: #FAFBFB;
  border-radius: 10px;
  padding: 5px 10px 5px 0;
`

export const ControlBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 30px;
`

export const LabelBlock = styled.div`
font-family: 'Roboto', sans-serif;
display: flex;
cursor: pointer;
opacity: 0.5;
align-items: center;
align-self: center;
justify-content: flex-start;
white-space: nowrap;
text-overflow: ellipsis;
text-align: left;
Line height: 24px;
padding-left: 10px;
${({ isBigChildren }) => isBigChildren && `
  overflow: hidden;
`}
${({ theme }) => {
  if (theme.themeName === LIGHT_THEME_NAME) {
    return `
      font-size: 1.6rem;
      font-weight: 500;
    `
  }
  return `
    font-weight: ${theme.fontWeights.bold};
    font-size: 1.4rem;
    line-height: 2.4rem;
  `
}}
`
export const WrapperTitile = styled.div`
`

export const Icon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 5px 10px;
`

export const FooterInfoBlock = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.5;
  text-align: center;
  margin-top: 20px;
`
